import { useState, useEffect } from 'react';

export default function Popup({ visible, onClose, children }) {
  const [isVisible, setIsVisible] = useState(false);
  const [showAnimation, setShowAnimation] = useState(false);

  useEffect(() => {
    if (visible) {
      setIsVisible(true);
      setTimeout(() => setShowAnimation(true), 10);
    } else {
      setShowAnimation(false);
      const timer = setTimeout(() => setIsVisible(false), 300);
      return () => clearTimeout(timer);
    }
  }, [visible]);

  if (!isVisible) return null;

  return (
    <div
      className={`fixed z-50 inset-0 flex items-center justify-center bg-black bg-opacity-50 transition-opacity ${
        showAnimation ? 'opacity-100' : 'opacity-0'
      }`}
      onClick={onClose}
    >
      <div
        className={`bg-white rounded-lg max-w-md transform transition-all duration-300 ${
          showAnimation ? 'translate-y-0 scale-100' : 'translate-y-4 scale-95'
        }`}
        onClick={(e) => e.stopPropagation()}
      >
        {children}
      </div>
    </div>
  );
}
